module.exports = __webpack_public_path__ + "static/media/questionnaire-sc.610e2700.jpg";